import { Handle } from '../Canvas';
import { DisplayWebContentWorkflow } from '../Workflows/DisplayWebContent/DisplayWebContentWorkflow';

export const DisplayWebContentNode = ({ id }) => {
  return (
    <>
      <Handle type="target" position={'top' as any} />
      <DisplayWebContentWorkflow id={id} />
      <Handle type="source" position={'bottom' as any} />
    </>
  );
};
